import * as React from 'react';
import { useStateValue } from "@/providers/state-provider";
import { FoodCategory } from '@/root/types';
import { NavMenuButton } from './nav-menu-button';

interface MenuNavProps {
  categories: FoodCategory[] | null;
  activeSectionIndex?: number | null;
  onMenuClick: (index: number) => void;
  menuRef: React.RefObject<HTMLElement>;
}

export const MenuNav: React.FC<MenuNavProps> = ({ categories, activeSectionIndex, onMenuClick, menuRef }) => {
  if (!categories) return null;

  return (
    <nav ref={menuRef} className='menuNav shadow-sm sm:shadow-none'>
      <div className='flexInner'>
        {categories && categories.map((category: FoodCategory, index) => {
          return (
            <NavMenuButton key={`menu-nav-button-${index}`} onMenuClick={onMenuClick} index={index} category={category} activeSection={index == activeSectionIndex} />
          );
        })}
      </div>
    </nav>
  );
};
